
export const TaskHeadings1 = [
    {
        name: 'Name',
        value: 'fullName'
    },
    {
        name: 'Mobile',
        value: 'mobile'
    },
    {
        name: 'Gender',
        value: 'gender'
    },
    {
        name: 'DOB',
        value: 'dob'
    },
    {
        name: 'License Number',
        value: 'licenseNo'
    },
    {
        name: 'Aadhaar Number',
        value: 'aadharNo'
    },
    {
        name: 'Address',
        value: 'addressLine'
    },
    {
        name: 'Driver type',
        value: 'driverTypeName'
    },
    {
        name: 'Service City',
        value: 'city'
    },
    
]

export const TaskHeadings2 = [
    
    {
        name: 'Aggregator',
        value: 'aggregatoreName'
    },
    {
        name: 'Cab type',
        value: 'carType'
    },
    {
        name: 'Cab number',
        value: 'mainCabNo'
    },
    {
        name: 'Status',
        value: 'driverCarStatus'
    },
    {
        name: 'Ratings',
        value: 'ratingAvg'
    },
    {
        name: 'Created on',
        value: 'createdOn'
    },
    {
        name: 'Created by',
        value: 'createdBy'
    },
    {
        name: 'Updated on',
        value: 'updatedOn'
    },
]

export const TaskHeadings3 = [
    {
        name: 'Updated by',
        value: 'updatedBy'
    },
    {
        name: 'Blocked reason',
        value: 'blockedReason'
    },
    {
        name: 'Blocked By',
        value: 'blockedBy'
    },
    {
        name: 'Deleted on',
        value: 'deletedOn'
    },
    {
        name: 'Deleted by',
        value: 'deletedBy'
    }
]



export const TaskData1 = {
    name: 'John Turner',
    phone_number_1: '+91 7865487640',
    phone_number_2: '+91 7865487640',
    gender: 'Male',
    dob: 'July 9, 1899',
    license_number: 'AN01 /2010/0051926',
    address: 'C/0 K K Complex Arshina Kunate Nelamangala,Banglore-562123',
}

export const TaskData2 = {
    driver_type: 'Primary',
    subscription: 'DODO',
    sevice_city: 'Delhi',
    aggregator: 'Megacabs Pvt. Ltd.',
    cab_type: 'MUV',
    cab_number: 'DL 2 C AD 1234'
}

export const TaskData3 = {
    status: 'Online',
    ratings: '3.5',
    created_on: 'Sep 28,2022',
    created_by: '-',
    deleted_on: '-',
    deleted_by: '-'
}